<swiper-container #swiperEl 
[attr.slides-per-view]="slidePerView" 
[attr.space-between]="spaceBetween"
[attr.loop]="loopMode" pagination="true" pagination-clickable="true" class="amdocs-swiper">
  <swiper-slide *ngFor="let item of items">
    <ng-container *ngTemplateOutlet="swiperContentItem; context: { $implicit: item }"></ng-container>
  </swiper-slide>
</swiper-container>